<p-card>
    <div class="p-grid">
        <div class="p-col-12 p-field">
            <label for="role">Rol</label>
            <p-dropdown name="role" optionValue="id" [options]="roles" [(ngModel)]="user.role_id" optionLabel="name"
                appendTo="body" placeholder="Selecciona un rol" [showClear]="true" (onChange)="loadRolePermissions()">
            </p-dropdown>
        </div>
        <div class="p-col-12" *ngIf="roles_configuration">
          <p-checkbox name="checked_all" [(ngModel)]="checked_all" (onChange)="check_all()" [binary]="true"></p-checkbox><label for="checked_all">Seleccionar todos.</label>
          <p-accordion>
            <div *ngFor="let permissionGroup of permissionsGroups">
              <p-accordionTab *ngIf="getPermissions(permissionGroup).length > 0">
                <ng-template pTemplate="header">{{permissionGroup.name}}</ng-template>
                <ng-template pTemplate="content">
                  <div class="p-grid">
                    <div *ngFor="let permission of getPermissions(permissionGroup)" class="p-col-4">
                      <label>
                        <p-checkbox name="groupname" value="{{permission.id}}" [(ngModel)]="selectedPermissions"
                                    *ngIf="rolePermissions.includes(permission.id+'')" disabled="true" ></p-checkbox>
                        <p-checkbox name="groupname" value="{{permission.id}}" [(ngModel)]="selectedPermissions"
                                    *ngIf="!rolePermissions.includes(permission.id+'')" (onChange)="updateChecked()"></p-checkbox>
                        {{permission.name}}
                      </label>
                    </div>
                  </div>
                </ng-template>
              </p-accordionTab>
            </div>
          </p-accordion>
        </div>
        <!--div *ngFor="let permissionGroup of permissionsGroups" class="p-col-3">
            <p-card [header]="permissionGroup.name">
                <div *ngFor="let permission of getPermissions(permissionGroup)" class="p-field p-col-12">
                    <label>
                        <p-checkbox name="groupname" value="{{permission.id}}" [(ngModel)]="selectedPermissions"
                            *ngIf="rolePermissions.includes(permission.id+'')" disabled="true"></p-checkbox>
                        <p-checkbox name="groupname" value="{{permission.id}}" [(ngModel)]="selectedPermissions"
                            *ngIf="!rolePermissions.includes(permission.id+'')"></p-checkbox>
                        {{permission.name}}
                    </label>
                </div>
            </p-card>
        </div>
        <div class="p-col-12">
            <button pButton class="p-ml-2" style="float: right;" (click)="save()" icon="pi pi-check"
                label="Guardar"></button>
            <button pButton class="p-button-secondary" style="float: right;" (click)="cancel()" icon="pi pi-times"
                label="Cancelar"></button>
        </div-->
    </div>
</p-card>
